export const en = {
  common: {
    save: "Save",
    cancel: "Cancel",
    delete: "Delete",
    edit: "Edit",
    view: "View",
    close: "Close",
    apply: "Apply",
    clear: "Clear",
    search: "Search",
    filter: "Filter",
    showFilter: "Show Filter",
    hideFilter: "Hide Filter",
    applyFilter: "Apply Filter",
    clearFilter: "Clear",
    loading: "Loading...",
    saving: "Saving...",
    pleaseWait: "Please wait...",
    somethingWentWrong: "Something went wrong. Please try again.",
    confirm: "Confirm",
    yes: "Yes",
    no: "No",
    ok: "OK",
    back: "Back",
    goBack: "Back",
    noRecords: "No records found",
    actions: "Actions",
    srNo: "#",
    date: "Date",
    fromDate: "From Date",
    toDate: "To Date",
    add: "Add",
    remove: "Remove",
    inProgress: "In Progress",
    completed: "Completed",
    downloadPdf: "Download PDF",
    update: "Update",
    submit: "Submit",
    continue: "Continue",
    name: "Name",
    notes: "Notes",
    note: "Note",
    status: "Status",
    amount: "Amount",
    rate: "Rate",
    quantity: "Quantity",
    selectDate: "Select Date",
    home: "Home",
    perPage: "Per Page",
    sortBy: "Sort By",
    ascending: "Ascending",
    descending: "Descending",
    exportReport: "Export Report",
    generateReport: "Generate Report",
    print: "Print",
    create: "Create",
    saved: "Saved",
    saveChanges: "Save Changes",
    open: "Open",
    refresh: "Refresh",
    select: "Select",
    none: "None",
    total: "Total",
    required: "Required",
    previous: "Previous",
    next: "Next",
    reportFileNotAvailable: "Report file not available.",
  },
  login: {
    title: "Login",
    subtitle: "Enter your details to access your account",
    erpSystem: "Hardware ERP System",
    mobileLabel: "Mobile Number",
    mobilePlaceholder: "Enter your mobile number",
    mobileRequired: "Mobile number is required",
    passwordLabel: "Password",
    passwordPlaceholder: "Enter your password",
    passwordRequired: "Password is required",
    forgotPassword: "Forgot Password?",
    forgotPasswordTooltip: "Please contact the admin.",
    loginButton: "Login",
    loggingIn: "Logging in...",
    copyright: "All rights reserved.",
    tagline: "A modern and complete solution to organize and streamline your business",
    feature1Title: "Secure and Reliable",
    feature1Desc: "Your data is completely safe",
    feature2Title: "Real-time Tracking",
    feature2Desc: "Instant updates and reports",
  },
  branch: {
    modalTitle: "Select Branch",
    modalDescription: "Please select your working branch to continue",
    selectPlaceholder: "Select a branch...",
    confirmButton: "Confirm",
    dropdownLabel: "Select Branch",
    selectBranch: "Select branch",
  },
  profile: {
    pageTitle: "Profile Settings",
    breadcrumbHome: "Home",
    userProfileTitle: "User Profile",
    userProfileSubtitle: "Update your personal information",
    changePasswordTitle: "Change Password",
    changePasswordSubtitle: "Update your password.",
    nameLabel: "Username",
    namePlaceholder: "Enter your username",
    nameRequired: "Name is required",
    emailLabel: "Email Address",
    emailPlaceholder: "Enter your email address",
    emailRequired: "Email is required",
    phoneLabel: "Mobile Number",
    updateProfileButton: "Save Changes",
    updatingProfile: "Saving...",
    oldPasswordLabel: "Old Password",
    oldPasswordPlaceholder: "Enter your old password",
    oldPasswordRequired: "Old password is required",
    newPasswordLabel: "New Password",
    newPasswordPlaceholder: "Enter your new password",
    newPasswordRequired: "New password is required",
    newPasswordMin: "Password must be at least 8 characters",
    confirmPasswordLabel: "Confirm Password",
    confirmPasswordPlaceholder: "Re-enter your new password",
    confirmPasswordRequired: "Please confirm your new password",
    confirmPasswordMatch: "Passwords do not match",
    changePasswordButton: "Change Password",
    changingPassword: "Changing...",
  },
  settings: {
    pageTitle: "Report Settings",
    breadcrumbHome: "Home",
    companyInfoTitle: "Company Information",
    companyInfoSubtitle: "Used in PDF report headers",
    addressTitle: "Address",
    addressSubtitle: "Address printed on every report",
    contactsTitle: "Contacts",
    contactsSubtitle: "Owner names and phone numbers",
    companyNameLabel: "Company Name",
    companyNamePlaceholder: "Company name shown on basic reports",
    companyNameReportLabel: "Company Name (Report Header)",
    companyNameReportPlaceholder: "Company name for detailed report headers",
    companyTaglineReportLabel: "Tagline",
    companyTaglineReportPlaceholder: "Tagline shown above the report header",
    companyAddress1Label: "Address Line 1",
    companyAddress1Placeholder: "Street address",
    companyAddress2Label: "Address Line 2",
    companyAddress2Placeholder: "City, postal code",
    companyOwner1Label: "Owner 1 Name",
    companyOwner1Placeholder: "Primary owner name",
    companyOwnerPhone1Label: "Owner 1 Phone",
    companyOwnerPhone1Placeholder: "Primary owner phone",
    companyOwner2Label: "Owner 2 Name",
    companyOwner2Placeholder: "Secondary owner name",
    companyOwnerPhone2Label: "Owner 2 Phone",
    companyOwnerPhone2Placeholder: "Secondary owner phone",
    saveButton: "Save Settings",
    saving: "Saving...",
  },
  dashboard: {
    pageTitle: "Dashboard",
    dailyUsageTitle: "Daily Usage Modules",
    stockManagementTitle: "Stock Management",
    masterTitle: "Master Modules",
    openButton: "Open",
    parties: { title: "Parties", description: "Manage party details", buttonLabel: "Parties" },
    accountTypes: { title: "Account Types", description: "Manage account type categories", buttonLabel: "Account Types" },
    accounts: { title: "Accounts", description: "Manage financial accounts", buttonLabel: "Accounts" },
    accountManagement: { title: "Account Management", description: "Manage account types and accounts", buttonLabel: "Account Types", secondaryButtonLabel: "Accounts" },
    items: { title: "Items", description: "Manage item master data" },
    processes: { title: "Sub-Processes", description: "Manage sub-process variants within a process (e.g. buffing/platting sub-types)" },
    processDefinitions: { title: "Processes", description: "Manage the manufacturing processes that drive orders, receives, and stock" },
    materials: { title: "Materials", description: "Manage material master data, including their sizes" },
    itemSizes: { title: "Item Sizes", description: "Manage item size master data" },
    users: { title: "Users", description: "Manage users and permissions" },
    stockSizes: { title: "Material Stock", description: "View stock by material", buttonLabel: "Open" },
    stockPieces: { title: "Pipe Pieces Stock", description: "View saved pipe pieces by material size", buttonLabel: "Open" },
    processItemsStock: { title: "Process Items Stock", description: "View ordered/received/available stock per process", buttonLabel: "Open" },
    processPartyStock: { title: "Process Party Stock", description: "View stock pending at parties per process", buttonLabel: "Open" },
    activityLogs: { title: "Activity Logs", description: "View system audit trail", buttonLabel: "View" },
    processModuleDescription: "Manage {name} orders and receives",
    processOrderButtonLabel: "Order",
    processReceiveButtonLabel: "Receive",
  },
  layout: {
    manageProfile: "Manage Profile",
    settings: "Settings",
    activityLogs: "Activity Logs",
    devFeedback: "Dev Feedback",
    logout: "Logout",
    selectBranchLabel: "Select Branch",
  },
  imageUpload: {
    imageAlt: "Item",
    changeImage: "Change Image",
    dropOrBrowse: "Drop image here or click to browse",
    formatHint: "JPG, PNG, GIF, WEBP",
    cropTitle: "Crop Image",
    cropDescription: "Drag to reposition. Pinch or use slider to zoom.",
    applyCrop: "Apply Crop",
  },
  users: {
    pageTitle: "User Management",
    breadcrumbHome: "Home",
    breadcrumbUsers: "Users",
    breadcrumbCreate: "Create User",
    breadcrumbEdit: "Edit User",
    addNewUser: "Add New User",
    filterToggle: "Filters",
    searchLabel: "Search",
    searchPlaceholder: "Search by ID, name, email or phone number...",
    sortByLabel: "Sort By",
    sortOrderLabel: "Sort Order",
    sortOptions: {
      id: "User ID",
      name: "User Name",
      email: "Email",
      created_at: "Created Date",
    },
    sortOrderOptions: {
      asc: "Low to High",
      desc: "High to Low",
    },
    filterTitle: "Filters",
    sortByPlaceholder: "Select option to sort users",
    sortOrderPlaceholder: "Select sort order for users",
    applyFilters: "Apply Filters",
    clearFilters: "Clear Filters",
    table: {
      srNo: "Sr.",
      user: "User",
      phone: "Phone Number",
      email: "Email",
      role: "Role",
      permissions: "Permissions",
      created: "Created",
      actions: "Actions",
    },
    noRecords: "No users found",
    loading: "Loading...",
    pageSizeLabel: "Per page:",
    pageOfLabel: "users",
    formTitle: "User Information",
    nameLabel: "Name",
    namePlaceholder: "Enter user name",
    nameRequired: "Name is required",
    phoneLabel: "Phone",
    phonePlaceholder: "Enter phone number",
    phoneRequired: "Phone is required",
    emailLabel: "Email",
    emailPlaceholder: "Enter email address",
    emailRequired: "Email is required",
    passwordLabel: "Password",
    passwordPlaceholder: "Enter password",
    passwordRequired: "Password is required",
    confirmPasswordLabel: "Confirm Password",
    confirmPasswordPlaceholder: "Re-enter password",
    confirmPasswordRequired: "Please confirm password",
    confirmPasswordMatch: "Passwords do not match",
    addressLabel: "Address",
    addressPlaceholder: "Enter address",
    branchPermissions: "Branch Permissions",
    roleLabel: "Role",
    rolePlaceholder: "Select a role...",
    permissionsLabel: "Permissions",
    selectAll: "Select All",
    defaultPermission: "Default",
    saveButton: "Save User",
    saving: "Saving...",
    updateButton: "Update User",
    updating: "Updating...",
    cancelButton: "Cancel",
    deleteConfirmTitle: "Are you sure?",
    deleteConfirmText: "You will not be able to revert this!",
    deleteConfirmButton: "Yes, delete it!",
    selectAllModule: "Select all permissions for this module",
    permissionsSelected: "permissions",
    creating: "Creating...",
    createButton: "Create User",
  },
  items: {
    pageTitle: "Item Management",
    breadcrumbHome: "Home",
    breadcrumbItems: "Items",
    addNewItem: "Add New Item",
    filterToggle: "Filters",
    searchLabel: "Search",
    searchPlaceholder: "Search by item name...",
    sortByLabel: "Sort By",
    sortOrderLabel: "Sort Order",
    sortOptions: {
      id: "Item ID",
      name: "Item Name",
      created_at: "Created Date",
    },
    sortOrderOptions: {
      asc: "Low to High",
      desc: "High to Low",
    },
    filterTitle: "Filters",
    sortByPlaceholder: "Select option to sort items",
    sortOrderPlaceholder: "Select sort order for items",
    applyFilters: "Apply Filters",
    clearFilters: "Clear Filters",
    table: {
      srNo: "Sr.",
      image: "Image",
      itemName: "Item Name",
      material: "Material",
      description: "Description",
      status: "Status",
      date: "Date",
      actions: "Actions",
    },
    noRecords: "No items found",
    loading: "Loading...",
    pageSizeLabel: "Per page:",
    pageOfLabel: "items",
    formTitle: "Item Information",
    nameLabel: "Item Name",
    namePlaceholder: "Enter item name",
    nameRequired: "Item name is required",
    materialLabel: "Material",
    materialPlaceholder: "Select material",
    materialSizeLabel: "Material Size",
    materialSizePlaceholder: "Select material size",
    selectMaterialFirst: "Select a material first",
    descriptionLabel: "Description",
    descriptionPlaceholder: "Enter item description",
    imageLabel: "Item Image",
    inInchLabel: "Inch Status",
    inInchPlaceholder: "Select inch status",
    inInchYes: "In inches",
    inInchNo: "Not in inches",
    saveButton: "Save",
    saving: "Saving...",
    cancelButton: "Cancel",
    deleteConfirmTitle: "Are you sure?",
    deleteConfirmText: "You will not be able to revert this!",
    deleteConfirmButton: "Yes, delete it!",
    inUseError: "Item is in use and cannot be deleted. Please remove related records first.",
  },
  materials: {
    pageTitle: "Material Management",
    breadcrumbHome: "Home",
    breadcrumbMaterials: "Materials",
    addNewMaterial: "Add New Material",
    filterToggle: "Filters",
    searchLabel: "Search",
    searchPlaceholder: "Search by material name...",
    sortByLabel: "Sort By",
    sortOrderLabel: "Sort Order",
    sortOptions: {
      id: "Material ID",
      name: "Material Name",
      created_at: "Created Date",
    },
    sortOrderOptions: {
      asc: "Low to High",
      desc: "High to Low",
    },
    filterTitle: "Filters",
    sortByPlaceholder: "Select option to sort materials",
    sortOrderPlaceholder: "Select sort order for materials",
    applyFilters: "Apply Filters",
    clearFilters: "Clear Filters",
    table: {
      srNo: "Sr.",
      name: "Material Name",
      description: "Description",
      date: "Date",
      actions: "Actions",
    },
    noRecords: "No materials found",
    loading: "Loading...",
    pageSizeLabel: "Per page:",
    pageOfLabel: "materials",
    formTitle: "Material Information",
    addNewMaterialShort: "Add Material",
    nameLabel: "Material Name",
    namePlaceholder: "Enter material name",
    nameRequired: "Material name is required",
    descriptionLabel: "Description",
    descriptionPlaceholder: "Enter description",
    saveButton: "Save",
    saving: "Saving...",
    cancelButton: "Cancel",
    deleteConfirmTitle: "Are you sure?",
    deleteConfirmText: "You will not be able to revert this!",
    deleteConfirmButton: "Yes, delete it!",
    inUseError: "Material is in use and cannot be deleted. Please remove related records first.",
    sizesLabel: "Material Sizes",
    sizeLabel: "Size",
    sizeNumber: "Size {n}",
    addSizeButton: "Add Size",
    removeSize: "Remove",
    sizePlaceholder: "Enter size (e.g. 12.5)",
    sizeRequired: "Size is required",
    sizePatternError: "Only numeric values with up to 1 decimal place allowed",
    sizeDescriptionPlaceholder: "Enter size description",
    defaultLabel: "Default",
    defaultHint: "Used when this material is picked elsewhere and no size is chosen yet.",
    sizesRequired: "Please add at least one material size.",
  },
  itemSizes: {
    pageTitle: "Item Size Management",
    breadcrumbHome: "Home",
    breadcrumbItemSizes: "Item Sizes",
    addNewItemSize: "Add New Item Size",
    filterToggle: "Filters",
    searchLabel: "Search",
    searchPlaceholder: "Search by item size...",
    sortByLabel: "Sort By",
    sortOrderLabel: "Sort Order",
    sortOptions: {
      id: "Item Size ID",
      size: "Size",
      created_at: "Created Date",
    },
    sortOrderOptions: {
      asc: "Low to High",
      desc: "High to Low",
    },
    filterTitle: "Filters",
    sortByPlaceholder: "Select option to sort item sizes",
    sortOrderPlaceholder: "Select sort order for item sizes",
    applyFilters: "Apply Filters",
    clearFilters: "Clear Filters",
    table: {
      srNo: "Sr.",
      itemSize: "Size",
      description: "Description",
      date: "Date",
      actions: "Actions",
    },
    noRecords: "No item sizes found",
    loading: "Loading...",
    pageSizeLabel: "Per page:",
    pageOfLabel: "item sizes",
    formTitle: "Item Size Information",
    sizeLabel: "Size",
    sizePlaceholder: "Enter size (e.g. 12.5)",
    sizeRequired: "Size is required",
    sizePatternError: "Only numeric values with up to 1 decimal place allowed",
    descriptionLabel: "Description",
    descriptionPlaceholder: "Enter item size description",
    saveButton: "Save",
    saving: "Saving...",
    cancelButton: "Cancel",
    deleteConfirmTitle: "Are you sure?",
    deleteConfirmText: "You will not be able to revert this!",
    deleteConfirmButton: "Yes, delete it!",
    inUseError: "Item size is in use and cannot be deleted. Please remove related records first.",
  },
  activityLogs: {
    pageTitle: "Activity Logs",
    breadcrumbHome: "Home",
    breadcrumbActivityLogs: "Activity Logs",
    searchPlaceholder: "Search description, module, IP...",
    searchButton: "Search",
    filterToggle: "Filters",
    filterModule: "Module",
    filterEvent: "Event",
    filterUser: "User",
    filterFromDate: "From Date",
    filterToDate: "To Date",
    allModules: "All modules",
    allEvents: "All events",
    allUsers: "All users",
    filterTitle: "Filters",
    searchLabel: "Search",
    applyFilters: "Apply Filters",
    clearFilters: "Clear Filters",
    eventCreated: "Created",
    eventUpdated: "Updated",
    eventDeleted: "Deleted",
    modules: {
      Account: "Account",
      AccountType: "Account Type",
      BranchSetting: "Settings",
      Items: "Item",
      ItemSize: "Item Size",
      Parties: "Party",
      PartiesItems: "Party Item",
      Payments: "Payment",
      ProcessOrder: "Process Order",
      ProcessReceive: "Process Receive",
      Processes: "Process",
      Sizes: "Size",
      User: "User",
    },
    colSr: "#",
    colTimestamp: "Timestamp",
    colUser: "User",
    colBranch: "Branch",
    colModule: "Module",
    colEvent: "Event",
    colRecordId: "Record ID",
    colActions: "Actions",
    viewButton: "View",
    noRecords: "No activity logs found",
    loading: "Loading...",
    pageSizeLabel: "Per page:",
    totalLabel: "Total",
    systemUser: "System",
    modalTitle: "Activity Detail",
    metaModule: "Module",
    metaEvent: "Event",
    metaUser: "User",
    metaBranch: "Branch",
    metaTimestamp: "Timestamp",
    metaIp: "IP Address",
    fieldChanges: "Field Changes",
    field: "Field",
    oldValue: "Old Value",
    newValue: "New Value",
    noFieldData: "No field data captured.",
    closeButton: "Close",
  },
  devFeedback: {
    hintBadge: "Feedback mode — triple-click anywhere",
    captureTitle: "Leave Feedback",
    captureDescription: "Tell us what's wrong or what could be better on this part of the screen.",
    metaPage: "Page",
    metaComponent: "Component",
    metaElement: "Element",
    severityLabel: "Type",
    severityBug: "Bug",
    severityUi: "UI Issue",
    severitySuggestion: "Suggestion",
    severityOther: "Other",
    messageLabel: "Feedback",
    messagePlaceholder: "Describe the issue or suggestion...",
    messageRequired: "Feedback message is required",
    cancelButton: "Cancel",
    submitButton: "Submit Feedback",
    submitting: "Submitting...",
    submitSuccess: "Feedback submitted successfully.",
    submitError: "Failed to submit feedback. Please try again.",
    overlayShowButton: "Show feedback notes on this page",
    overlayHideButton: "Hide feedback notes",
    overlayNoRecords: "No open feedback on this page",

    pageTitle: "Dev Feedback",
    breadcrumbHome: "Home",
    breadcrumbDevFeedback: "Dev Feedback",
    filterToggle: "Filters",
    filterTitle: "Filters",
    searchLabel: "Search",
    searchPlaceholder: "Search message, page, component...",
    filterStatus: "Status",
    filterSeverity: "Type",
    filterFromDate: "From Date",
    filterToDate: "To Date",
    allStatuses: "All statuses",
    allSeverities: "All types",
    applyFilters: "Apply Filters",
    clearFilters: "Clear Filters",
    statusOpen: "Open",
    statusInProgress: "In Progress",
    statusResolved: "Resolved",
    statusClosed: "Closed",
    colSr: "#",
    colTimestamp: "Timestamp",
    colUser: "User",
    colPage: "Page",
    colComponent: "Component",
    colType: "Type",
    colStatus: "Status",
    colActions: "Actions",
    viewButton: "View",
    deleteButton: "Delete",
    noRecords: "No feedback captured yet",
    loading: "Loading...",
    pageSizeLabel: "Per page:",
    systemUser: "Unknown",
    modalTitle: "Feedback Detail",
    metaUser: "Reported By",
    metaTimestamp: "Reported At",
    metaUrl: "URL",
    metaSelector: "Element Selector",
    metaElementText: "Element Text",
    metaViewport: "Viewport",
    metaBrowser: "Browser",
    metaIp: "IP Address",
    messageSectionTitle: "Feedback Message",
    statusSectionTitle: "Review",
    statusLabel: "Status",
    resolutionNoteLabel: "Resolution Note",
    resolutionNotePlaceholder: "Add a note for other developers (optional)...",
    saveButton: "Save",
    saving: "Saving...",
    updateSuccess: "Feedback updated successfully.",
    updateError: "Failed to update feedback. Please try again.",
    deleteConfirmTitle: "Delete Feedback?",
    deleteConfirmMessage: "This feedback entry will be permanently deleted.",
    deleteConfirmButton: "Delete",
    deleteSuccess: "Feedback deleted successfully.",
    deleteError: "Failed to delete feedback. Please try again.",
    closeButton: "Close",
  },
  parties: {
    pageTitle: "Party Management",
    breadcrumbHome: "Home",
    breadcrumbParties: "Parties",
    addNewParty: "Add New Party",
    filterToggle: "Filters",
    searchLabel: "Search",
    searchPlaceholder: "Search by firm name, party name, phone...",
    typeLabel: "Type",
    typePlaceholder: "Select type",
    typeRequired: "Please select at least one type",
    allTypes: "All Types",
    ratesCountLabel: "Rate rows",
    types: {
      purchase: "Casting",
      cutting: "Cutting",
      turning: "Turning",
      buff: "Buff",
      colorProcess: "Color Process",
    },
    sortByLabel: "Sort By",
    sortOrderLabel: "Sort Order",
    sortOptions: {
      id: "Party ID",
      firm_name: "Firm Name",
      name: "Party Name",
      type: "Type",
      created_at: "Created Date",
    },
    sortOrderOptions: {
      asc: "Low to High",
      desc: "High to Low",
    },
    filterTitle: "Filters",
    sortByPlaceholder: "Select option to sort parties",
    sortOrderPlaceholder: "Select sort order for parties",
    applyFilters: "Apply Filters",
    clearFilters: "Clear Filters",
    table: {
      srNo: "Sr.",
      firmName: "Firm Name",
      partyName: "Party Name",
      type: "Type",
      phone: "Phone",
      items: "Items",
      pendingPayment: "Pending Pay.",
      receivedPayment: "Received Pay.",
      date: "Date",
      actions: "Actions",
    },
    noRecords: "No parties found",
    loading: "Loading...",
    pageSizeLabel: "Per page:",
    pageOfLabel: "parties",
    pendingPaymentLabel: "Pending Payment",
    receivedPaymentLabel: "Received Payment",
    formTitle: "Party Information",
    firmNameLabel: "Firm Name",
    firmNamePlaceholder: "Enter firm name",
    firmNameRequired: "Firm name is required",
    nameLabel: "Party Name",
    namePlaceholder: "Enter party name",
    phoneLabel: "Phone",
    phonePlaceholder: "Enter phone number",
    wpPhoneLabel: "WhatsApp Number",
    wpPhonePlaceholder: "Enter WhatsApp number",
    addressLabel: "Address",
    addressPlaceholder: "Enter party address",
    saveButton: "Save",
    saving: "Saving...",
    cancelButton: "Cancel",
    deleteConfirmTitle: "Are you sure?",
    deleteConfirmText: "You will not be able to revert this!",
    deleteConfirmButton: "Yes, delete it!",
    inUseError: "Party is in use and cannot be deleted. Please remove related records first.",
    paymentAction: "Payment",
    itemsAction: "Items",
    editAction: "Edit",
    deleteAction: "Delete",
    viewAction: "View Details",
    itemForm: {
      title: "Item Information",
      itemLabel: "Item",
      processLabel: "Process",
      noItemsMessage: "No items found. Click the Add Item button to add a new one.",
      noProcessesMessage: "No processes found. Click the Add Process button to add a new one.",
      enterItemName: "Enter item name",
      selectItemName: "Select item name",
      enterProcessName: "Enter process name",
      selectProcessName: "Select process name",
      enterProcessRate: "Enter process rate",
      enterWeightRate: "Rate by weight",
      enterWeightRateRequired: "Enter rate by weight",
      enterPieceRate: "Rate by piece",
      enterPieceRateRequired: "Enter rate by piece",
      addItem: "Add Item",
      addProcess: "Add Process",
    },
  },
  processes: {
    pageTitle: "Sub-Process Management",
    breadcrumbHome: "Home",
    breadcrumbProcesses: "Sub-Processes",
    addNewProcess: "Add New Sub-Process",
    filterToggle: "Filters",
    searchLabel: "Search",
    searchPlaceholder: "Search by sub-process name...",
    sortByLabel: "Sort By",
    sortOrderLabel: "Sort Order",
    sortOptions: {
      id: "Sub-Process ID",
      name: "Sub-Process Name",
      created_at: "Created Date",
    },
    sortOrderOptions: {
      asc: "Low to High",
      desc: "High to Low",
    },
    filterTitle: "Filters",
    typeFilterLabel: "Type",
    typeFilterPlaceholder: "Select type",
    sortByPlaceholder: "Select option to sort sub-processes",
    sortOrderPlaceholder: "Select sort order for sub-processes",
    applyFilters: "Apply Filters",
    clearFilters: "Clear Filters",
    table: {
      srNo: "Sr.",
      processName: "Sub-Process Name",
      type: "Type",
      description: "Description",
      date: "Date",
      actions: "Actions",
    },
    noRecords: "No sub-processes found",
    loading: "Loading...",
    pageSizeLabel: "Per page:",
    pageOfLabel: "sub-processes",
    formTitle: "Sub-Process Information",
    nameLabel: "Sub-Process Name",
    namePlaceholder: "Enter sub-process name",
    nameRequired: "Sub-process name is required",
    typeLabel: "Type",
    typePlaceholder: "Select type",
    typeRequired: "Type is required",
    modePolicyLabel: "Mode Policy",
    modePolicyPlaceholder: "Inherit from process",
    modePolicyInHouse: "In-house only",
    modePolicyOutsource: "Outsource only",
    modePolicyBoth: "Both (defaults to in-house)",
    modePolicyInheritHint: "Leave blank to follow the process's own mode policy.",
    nextProcessLabel: "Next Process (આગળ મોકલો)",
    nextProcessPlaceholder: "Select allowed next processes",
    nextProcessInheritHint: "Leave empty to inherit the process's own list.",
    nextProcessMandatoryLabel: "Forward Mandatory",
    nextProcessMandatoryPlaceholder: "Inherit from process",
    nextProcessMandatoryInherit: "Inherit from process",
    nextProcessMandatoryYes: "Yes, mandatory",
    nextProcessMandatoryNo: "No, optional",
    nextProcessListRequired: "Select at least one next process when Forward is mandatory.",
    descriptionLabel: "Description",
    descriptionPlaceholder: "Enter sub-process description",
    saveButton: "Save",
    saving: "Saving...",
    cancelButton: "Cancel",
    deleteConfirmTitle: "Are you sure?",
    deleteConfirmText: "You will not be able to revert this!",
    deleteConfirmButton: "Yes, delete it!",
    inUseError: "Sub-process is in use and cannot be deleted. Please remove related records first.",
  },
  processRates: {
    pageTitle: "Rate Card",
    inHousePageTitle: "In-house Rate",
    noProcessesAssigned: "This party has no processes assigned yet.",
    noRows: "No rates added yet.",
    subProcessLabel: "Sub Process",
    itemLabel: "Item",
    allSubProcesses: "All sub processes",
    allItems: "All items",
    rateLabel: "Rate",
    rateRequired: "Please enter a valid rate.",
    addRow: "Add Rate",
    save: "Save",
    saving: "Saving...",
  },
  processDefinitions: {
    pageTitle: "Processes",
    breadcrumbHome: "Home",
    breadcrumbList: "Processes",
    addNewProcess: "Add New Process",
    formTitle: "Process Information",
    editingPrefix: "Editing:",
    slugLabel: "Slug",
    slugPlaceholder: "e.g. vmc",
    slugImmutableHint: "Slug can't be changed after a process is created.",
    slugInvalid: "Slug may only contain letters, numbers, dashes and underscores.",
    nameLabel: "Name",
    namePlaceholder: "Enter process name",
    nameRequired: "Name is required",
    nameGuLabel: "Name (Gujarati)",
    nameGuPlaceholder: "Enter Gujarati name (optional)",
    rateBasisLabel: "Rate Basis",
    rateBasisPlaceholder: "Select rate basis",
    rateBasisRequired: "Please select a valid rate basis",
    rateBasisPiece: "Piece",
    rateBasisWeight: "Weight",
    rateBasisSize: "Size",
    sortOrderLabel: "Sort Order",
    sortOrderPlaceholder: "Leave blank to add at the end",
    isActiveLabel: "Active (shows on dashboard)",
    hasOrderLabel: "Has Order",
    hasReceiveLabel: "Has Receive",
    modePolicyLabel: "Mode Policy",
    modePolicyPlaceholder: "Select mode policy",
    modePolicyRequired: "Please select a mode policy",
    modePolicyInHouse: "In-house only",
    modePolicyOutsource: "Outsource only",
    modePolicyBoth: "Both (defaults to in-house)",
    nextProcessLabel: "Next Process (આગળ મોકલો)",
    nextProcessPlaceholder: "Select allowed next processes",
    nextProcessHint: "Leave empty to allow forwarding to any active process.",
    nextProcessMandatoryLabel: "Forward is mandatory on receive",
    nextProcessListRequired: "Select at least one next process when Forward is mandatory.",
    cancelButton: "Cancel",
    saveButton: "Save",
    saving: "Saving...",
    loading: "Loading...",
    noRecords: "No processes found",
    hasOrderBadge: "Order",
    hasReceiveBadge: "Receive",
    activeBadge: "Active",
    inactiveBadge: "Inactive",
    deleteConfirmTitle: "Are you sure?",
    deleteConfirmText: "You will not be able to revert this!",
    deleteConfirmButton: "Yes, delete it!",
    table: {
      srNo: "Sr.",
      flags: "Flags",
      status: "Status",
      actions: "Actions",
    },
  },
  accountTypes: {
    pageTitle: "Account Type Management",
    breadcrumbHome: "Home",
    breadcrumbAccountTypes: "Account Types",
    addNewAccountType: "Add New Type",
    filterToggle: "Filters",
    searchLabel: "Search",
    searchPlaceholder: "Search by name, phone or description...",
    sortByLabel: "Sort By",
    sortOrderLabel: "Sort Order",
    sortOptions: {
      id: "Account Type ID",
      name: "Name",
      created_at: "Created Date",
    },
    sortOrderOptions: {
      asc: "Low to High",
      desc: "High to Low",
    },
    filterTitle: "Filters",
    sortByPlaceholder: "Select option to sort account types",
    sortOrderPlaceholder: "Select sort order for account types",
    applyFilters: "Apply Filters",
    clearFilters: "Clear Filters",
    table: {
      srNo: "Sr.",
      name: "Name",
      phone: "Phone",
      totalIncome: "Total Income",
      totalExpenses: "Total Expenses",
      description: "Description",
      date: "Date",
      actions: "Actions",
    },
    noRecords: "No account types found",
    loading: "Loading...",
    pageSizeLabel: "Per page:",
    pageOfLabel: "account types",
    formTitle: "Account Type Information",
    nameLabel: "Account Type Name",
    namePlaceholder: "Enter account type name",
    nameRequired: "Account type name is required",
    phoneLabel: "Phone Number",
    phonePlaceholder: "Enter phone number",
    descriptionLabel: "Description",
    descriptionPlaceholder: "Enter description",
    saveButton: "Save",
    saving: "Saving...",
    cancelButton: "Cancel",
    deleteConfirmTitle: "Are you sure?",
    deleteConfirmText: "You will not be able to revert this!",
    deleteConfirmButton: "Yes, delete it!",
  },
  accounts: {
    pageTitle: "Account Management",
    breadcrumbHome: "Home",
    breadcrumbAccounts: "Accounts",
    addIncome: "Add Income",
    addExpense: "Add Expense",
    filterToggle: "Filters",
    searchLabel: "Search",
    searchPlaceholder: "Search by note...",
    fromDateLabel: "From Date",
    toDateLabel: "To Date",
    partyLabel: "Party",
    partyPlaceholder: "Select party",
    accountTypeLabel: "Account Type",
    accountTypePlaceholder: "Select account type",
    statusLabel: "Status",
    statusPlaceholder: "Select status",
    statusOptions: {
      income: "Income",
      expense: "Expense",
    },
    sortByLabel: "Sort By",
    sortOrderLabel: "Sort Order",
    sortOptions: {
      id: "Account ID",
      amount: "Amount",
      status: "Status",
      created_at: "Created Date",
    },
    sortOrderOptions: {
      asc: "Low to High",
      desc: "High to Low",
    },
    filterTitle: "Filters",
    sortByPlaceholder: "Select option to sort accounts",
    sortOrderPlaceholder: "Select sort order for accounts",
    applyFilters: "Apply Filters",
    clearFilters: "Clear Filters",
    generateReport: "Generate Report",
    generateReportDateRequired: "Please select both From Date and To Date.",
    totalIncome: "Total Income",
    totalExpenses: "Total Expenses",
    balance: "Balance",
    table: {
      srNo: "Sr.",
      accountTypeParty: "Account Type / Party",
      status: "Status",
      amount: "Amount",
      note: "Note",
      date: "Date",
      actions: "Actions",
    },
    income: "Income",
    expense: "Expense",
    noRecords: "No accounts found",
    loading: "Loading...",
    pageSizeLabel: "Per page:",
    pageOfLabel: "accounts",
    incomeFormTitle: "Income Information",
    expenseFormTitle: "Expense Information",
    accountTypeRequired: "Account type is required",
    amountLabel: "Amount",
    amountPlaceholder: "Enter amount",
    amountRequired: "Amount is required",
    descriptionLabel: "Description",
    descriptionPlaceholder: "Enter description",
    saveButton: "Save",
    saving: "Saving...",
    cancelButton: "Cancel",
    deleteConfirmTitle: "Are you sure?",
    deleteConfirmText: "You will not be able to revert this!",
    deleteConfirmButton: "Yes, delete it!",
  },
  payments: {
    breadcrumbHome: "Home",
    breadcrumbParties: "Parties",
    breadcrumbPayments: "Payments",
    pageTitle: "Payment Details",
    summary: {
      totalInvoice: "Total Invoice",
      totalReceived: "Total Paid",
      totalAdjustment: "Total Adjustment",
      balance: "Balance",
    },
    actions: {
      createInvoice: "Create Invoice",
      receivedPayment: "Paid Payment",
      adjustment: "Adjustment",
    },
    filterToggle: "Filters",
    filterTitle: "Filters",
    searchLabel: "Search",
    searchPlaceholder: "Search payments...",
    fromDateLabel: "From Date",
    toDateLabel: "To Date",
    sortByLabel: "Sort By",
    sortByPlaceholder: "Select sort option",
    sortOrderLabel: "Sort Order",
    sortOrderPlaceholder: "Select sort order",
    sortOptions: {
      id: "Payment ID",
      amount: "Amount",
      created_at: "Created Date",
    },
    sortOrderOptions: {
      asc: "Low to High",
      desc: "High to Low",
    },
    clearFilters: "Clear Filters",
    applyFilters: "Apply Filters",
    generateReport: "Generate Report",
    generateReportDateRequired: "Please select both From Date and To Date.",
    generateReportError: "Something went wrong. Please try again.",
    table: {
      srNo: "Sr.",
      paymentId: "Account ID",
      type: "Type",
      details: "Details",
      amount: "Amount",
      credit: "Credit",
      debit: "Debit",
      balance: "Balance",
      date: "Date",
      actions: "Actions",
    },
    types: {
      invoice: "Credit",
      receivedPayment: "Debit",
      adjustment: "Adjustment",
      cashPayment: "Cash Payment",
    },
    details: {
      amountAdded: "Amount Added",
      amountDeducted: "Amount Deducted",
    },
    sourceLabels: {
      processReceive: "Process Receive",
    },
    tooltips: {
      openProcessReceive: "Open process receive",
    },
    sourceManaged: {
      tooltip: "This entry is managed by its source module. Edit or delete it from there.",
      pdfTooltip: "Download report (managed by source module)",
    },
    noRecords: "No payment details found",
    loading: "Loading...",
    pageSizeLabel: "Per page:",
    pageOfLabel: "payments",
    deleteConfirmTitle: "Are you sure?",
    deleteConfirmText: "You will not be able to revert this!",
    deleteConfirmButton: "Yes, delete it!",
    forms: {
      invoiceTitle: "Invoice Information",
      receivedTitle: "Paid Payment Information",
      adjustmentTitle: "Adjustment Information",
      editInvoiceTitle: "Edit Invoice Information",
    },
    formFields: {
      status: "Status",
      fromDate: "From Date",
      toDate: "To Date",
      paymentAmount: "Payment Amount",
      taxAmount: "Tax Amount",
      roundOff: "Round Off",
      totalAmount: "Total Amount",
      amount: "Amount",
      note: "Note",
    },
    statusOptions: {
      basedOnReceived: "Based on received quantity",
      basedOnReturned: "Based on returned quantity",
    },
    adjustmentTypes: {
      extra: "Extra",
      roundOff: "Round Off",
      taxAmount: "Tax Amount",
      rejectedQuality: "Rejected due to quality",
      rejectedFewerPieces: "Rejected due to fewer pieces",
      lb: "LB",
    },
    adjustmentStatus: {
      addAmount: "Add Amount",
      deductAmount: "Deduct Amount",
    },
    buttons: {
      continue: "Continue",
      close: "Close",
      saving: "Saving...",
    },
    pendingPayments: {
      title: "Pending Payments",
      fromDate: "From Date",
      toDate: "To Date",
      noRecords: "No pending payment details found",
    },
    pdfButton: "PDF",
  },
  notFound: {
    title: "Page Not Found (404)",
    description: "Sorry, the page you are looking for is not available on our website. Perhaps the URL you entered is incorrect or the page has been removed by us.",
    goToMain: "Go to the main page: To visit the main page of our website",
    clickHere: "Click here.",
  },
  stock: {
    breadcrumbHome: "Home",
    navSizes: "Material Stock",
    navItems: "Items Stock",
    navWipParties: "Party Order Stock",
    navPieces: "Pipe Pieces Stock",
    navProcessItems: "Process Items Stock",
    navProcessParties: "Process Party Stock",
    sizesPageTitle: "Material Stock",
    itemsPageTitle: "Items Stock",
    wipPageTitle: "Party Order Stock",
    piecesPageTitle: "Pipe Pieces Stock",
    processItemsPageTitle: "Process Items Stock",
    processPartyPageTitle: "Process Party Stock",
    sizeLabel: "Material",
    itemLabel: "Item",
    itemSizeLabel: "Item Size",
    partyLabel: "Party",
    pipeSizeLabel: "Pipe Size",
    stageLabel: "Stage",
    statusLabel: "Status",
    processLabel: "Process",
    qtyInLabel: "Received",
    qtyOutLabel: "Sent",
    qtySentLabel: "Sent",
    qtyReceivedLabel: "Received",
    stockLabel: "Stock",
    wipColLabel: "WIP",
    remainingInchesLabel: "Remaining",
    initialInchesLabel: "Initial",
    sourceOrderLabel: "Order",
    orderedQtyLabel: "Ordered",
    routedQtyLabel: "Routed",
    availableQtyLabel: "Available",
    pendingQtyLabel: "Pending",
    totalIn: "Total In",
    totalOut: "Total Out",
    totalStock: "Total Stock",
    totalPiecesLabel: "Total Pieces",
    totalSizeLabel: "Total",
    selectSize: "Select Material",
    selectItem: "Select Item",
    selectItemSize: "Select Item Size",
    selectParty: "Select Party",
    selectStatus: "Select Status",
    selectProcess: "Select Process",
    selectPipeSize: "Select Pipe Size",
    stageAll: "All Stages",
    stageCuttingCompleted: "Cutting Completed",
    stageTurningCompleted: "Turning Completed",
    stageBuffingCompleted: "Buffing Completed",
    stagePlattingCompleted: "Platting Completed",
    processAll: "All Processes",
    processCutting: "Cutting",
    processTurning: "Turning",
    processBuffing: "Buffing",
    processPlatting: "Platting",
    sortByLabel: "Sort By",
    sortOrderLabel: "Sort Order",
    sortBy: {
      sizeName: "Material Name",
      itemName: "Item Name",
      stage: "Stage",
      qtyIn: "Received Qty",
      qtyOut: "Sent Qty",
      qtySent: "Sent Qty",
      qtyReceived: "Received Qty",
      stock: "Stock",
      wip: "WIP",
      party: "Party",
      partyName: "Party Name",
      pipeSizeName: "Pipe Size",
      remainingInches: "Remaining",
      initialInches: "Initial",
      orderedQty: "Ordered Qty",
      routedQty: "Routed Qty",
      availableQty: "Available Qty",
      pendingQty: "Pending Qty",
    },
    sortOrderOptions: {
      asc: "Low to High",
      desc: "High to Low",
    },
    searchLabel: "Search",
    searchPlaceholder: "Search by size name...",
    filterToggle: "Filters",
    exportReport: "Export Report",
    filterTitle: "Filters",
    applyFilters: "Apply Filters",
    clearFilters: "Clear Filters",
    loading: "Loading...",
    noRecords: "No stock records found",
    pageSizeLabel: "Per page:",
    pageOfLabel: "records",
    table: {
      srNo: "Sr.",
      actions: "Actions",
    },
  },
  processOrders: {
    pageTitle: "Process Order",
    breadcrumbHome: "Home",
    breadcrumbList: "Process Orders",
    addTitle: "New Process Order",
    editTitle: "Edit Process Order",
    viewTitle: "Process Order Details",
    addNew: "Add New Order",
    modeLabel: "Mode",
    modeInHouse: "In-house",
    modeOutsource: "Outsource",
    modeLockedHint: "This process cannot be outsourced.",
    modeLockedOutsourceHint: "This process can only be outsourced.",
    modeLockedBySubProcess: "Locked by the selected sub process.",
    subProcessModeConflict: "The selected sub processes don't agree on in-house or outsource — remove one before saving.",
    partyLabel: "Party",
    partyRequiredOutsource: "Please select a party for outsource work.",
    selectParty: "Select Party",
    dateLabel: "Date",
    dateRequired: "Date is required",
    itemsLabel: "Items",
    addItem: "Add Item",
    subProcessLabel: "Sub Process",
    selectSubProcess: "Select Sub Process",
    itemLabel: "Item",
    selectItem: "Select Item",
    itemRequired: "Item is required",
    rawMaterialLabel: "Raw Material",
    selectRawMaterial: "Select Raw Material",
    rawMaterialRequired: "Raw material is required",
    rawMaterialSizeLabel: "Raw Material Size",
    selectRawMaterialSize: "Select Raw Material Size",
    materialLabel: "Material",
    selectMaterial: "Select Material",
    selectMaterialFirst: "Select a material first",
    itemSizeLabel: "Item Size",
    selectItemSize: "Select Item Size",
    itemSizeRequired: "Please select item size",
    cuttingSizeLabel: "Cutting Size",
    cuttingSizePlaceholder: "Enter cutting size",
    cuttingSizeRequired: "Please enter cutting size",
    sizeLabel: "Size",
    selectSize: "Select Size",
    weightLabel: "Weight",
    weightRequired: "Weight is required",
    typeLabel: "Type",
    selectType: "Select Type",
    typeAluminium: "Aluminium",
    typeWhiteMetal: "White Metal",
    typeRequired: "Please select type",
    qtyLabel: "Qty",
    qtyRequired: "Qty is required",
    materialSizeLabel: "Material Size",
    selectMaterialSize: "Material Size",
    materialSizeRequired: "Please select material size",
    selectItemFirst: "Select an item first",
    itemNoMaterialAssigned: "This item has no material assigned. Set one in Materials master first.",
    materialGroupTitle: "Material Group - Pipe Calculation",
    materialGroupDescription: "Predicted pipe usage per material size",
    itemsCount: "items",
    totalPipesNeeded: "Total Pipes Needed",
    leftoverLabel: "Leftover",
    fromLeftover: "From leftover: {n} pcs",
    newPipes: "New Pipes: {n}",
    noNewPipesNeeded: "No new pipes needed",
    savedPiecesLabel: "Will be saved ({n} pcs)",
    availableLeftoverPipes: "Available leftover pipes (for this material size)",
    leftoverFromPreviousOrder: "Leftover from previous order:",
    nangUnit: "pcs",
    materialDetailsTitle: "Material Details",
    cancelButton: "Cancel",
    saveButton: "Save",
    saveButtonLabel: "Add Order",
    editButtonLabel: "Update Order",
    saving: "Saving...",
    filterToggle: "Filters",
    filterTitle: "Filters",
    searchLabel: "Search",
    searchPlaceholder: "Party name...",
    fromDateLabel: "From Date",
    toDateLabel: "To Date",
    clearFilters: "Clear Filters",
    exportReport: "Export Report",
    applyFilters: "Apply Filters",
    dateRangeRequired: "Please select both From Date and To Date.",
    sortByLabel: "Sort By",
    sortOrderLabel: "Sort Order",
    sortByPlaceholder: "Select sort option",
    sortOrderPlaceholder: "Select sort order",
    sortOptions: { id: "ID", date: "Date" },
    sortOrderOptions: { asc: "Ascending", desc: "Descending" },
    viewBreadcrumb: "Details",
    backToList: "Back",
    exportPdf: "Generate PDF",
    orderId: "Order ID",
    totalItems: "Total Items",
    totalQty: "Total Qty",
    accountInfo: "Account Info",
    createdAt: "Created At",
    updatedAt: "Last Updated",
    loading: "Loading...",
    noRecords: "No process orders found",
    pageSizeLabel: "Per page",
    noItemsText: "No items. Click 'Add Item' to add.",
    removeItem: "Remove",
    deleteConfirmTitle: "Delete Process Order",
    deleteConfirmText: "Are you sure you want to delete this order?",
    deleteConfirmButton: "Delete",
    cantEditAfterReceive: "Already received, cannot edit",
    cantDeleteAfterReceive: "Already received, cannot delete",
    processNotSupported: "This process isn't available on this screen yet.",
    table: {
      srNo: "#",
      party: "Party",
      date: "Date",
      subProcess: "Sub Process",
      qty: "Qty",
      actions: "Actions",
      materialSize: "Material Size",
      totalNewPipes: "New Pipes",
      usedLeftover: "Used Leftovers",
      savedLeftover: "Saved Leftovers",
    },
  },
  processReceives: {
    pageTitle: "Process Receives",
    breadcrumbHome: "Home",
    breadcrumbList: "Process Receives",
    addTitle: "Add Receive",
    editTitle: "Edit Process Receive",
    viewTitle: "Process Receive Details",
    modeLabel: "Mode",
    modeLockedHint: "This process cannot be outsourced.",
    modeLockedOutsourceHint: "This process can only be outsourced.",
    partyLabel: "Party",
    selectParty: "Select Party",
    dateLabel: "Date",
    dateRequired: "Please enter date",
    pendingOrderItemsLabel: "Pending Order Items",
    pendingItemsHelp: "Select items to receive, enter quantity and rate",
    selectPartyToView: "Select the vendor party to view their pending outsource orders",
    loadingItems: "Loading...",
    noPendingItems: "No pending orders",
    receiveQtyLabel: "Receive Quantity",
    rateLabel: "Rate",
    qtyMustNotBeNegative: "Quantity cannot be negative",
    qtyRequired: "Enter quantity",
    overReceive: "Over-receive",
    rateMustNotBeNegative: "Rate cannot be negative",
    rateRequired: "Enter rate",
    selectAtLeastOneItem: "Select at least one item.",
    saveReceiveButton: "Save Receive",
    updateReceiveButton: "Update Receive",
    saving: "Saving...",
    cancelButton: "Cancel",
    orderLabel: "Order #{n}",
    itemSizeLabel: "Item Size",
    subProcessLabel: "Sub Process",
    weightLabel: "Weight",
    orderQtyLabel: "Order",
    receivedQtyLabel: "Received",
    remainingQtyLabel: "Remaining",
    closeItemLabel: "Close item",
    closeItemHint: "(Will not appear in pending list again)",
    nextProcessLabel: "Route To",
    nextProcessPlaceholder: "Select next process",
    nextProcessRequired: "Please select a next process (Forward) before receiving",
    nextModeLabel: "Mode",
    nextModePlaceholder: "Select in-house or outsource",
    nextModeRequired: "Please select in-house or outsource",
    inHouseLabel: "In-house",
    outsourceLabel: "Outsource",
    rateNotSetForParty: "No rate is set for this party and process.",
    setRateLink: "Set rate",
    totalComputedOnSaveHint: "Subtotal, tax amount, and grand total are computed on save.",
    nextPartyLabel: "Vendor",
    nextPartyPlaceholder: "Select vendor party",
    nextPartyRequired: "Please select a vendor party",
    partyRequired: "Please select a party for outsource work",
    typeLabel: "Type",
    selectType: "Select Type",
    typeAluminium: "Aluminium",
    typeWhiteMetal: "White Metal",
    voucherLabel: "Voucher No",
    voucherPlaceholder: "Voucher No",
    sizeLabel: "Size",
    rawMaterialSizeLabel: "Raw Material Size",
    pipeSizeLabel: "Pipe Size",
    subtotalLabel: "Subtotal",
    discountLabel: "Discount",
    taxRateLabel: "Tax Rate %",
    taxAmountLabel: "Tax Amount",
    roundOffLabel: "Round Off",
    grandTotal: "Grand Total",
    cantEditMessage: "Items in this receive have already been re-received and cannot be edited.",
    notFound: "Receive details not found",
    totalQty: "Total Quantity",
    totalAmount: "Total Amount",
    partyInfoTitle: "Party Information",
    itemsInfoTitle: "Item Information",
    accountInfoTitle: "Account Information",
    lastUpdated: "Last updated",
    createdAt: "Created at",
    deleteConfirmText: "Are you sure you want to delete this receive?",
    deleteConfirmTitle: "Delete Process Receive",
    deleteConfirmButton: "Delete",
    calculationPrefix: "Calculation:",
    itemLabel: "Item",
    addReceiveButton: "Add Receive",
    receiveIdLabel: "Receive ID",
    filterToggle: "Filter",
    filterTitle: "Filter",
    searchLabel: "Search",
    searchPlaceholder: "Search...",
    fromDateLabel: "From Date",
    toDateLabel: "To Date",
    sortByLabel: "Sort By",
    sortOrderLabel: "Sort Order",
    sortByPlaceholder: "Select sort option",
    sortOrderPlaceholder: "Select sort order",
    clearFilters: "Clear",
    applyFilters: "Apply Filters",
    exportReport: "Export Report",
    pageSizeLabel: "Per Page",
    loading: "Loading...",
    noReceivesFound: "No receives found",
    cantDeleteAfterReceive: "Item received again, cannot delete",
    cantEditAfterReceive: "Item received again, cannot edit",
    sortOptions: { id: "ID", date: "Date", grandTotal: "Total Amount" },
    sortOrderOptions: { asc: "Ascending", desc: "Descending" },
    dateRangeRequired: "Please select both From Date and To Date.",
    processNotSupported: "This process isn't available on this screen yet.",
    viewBreadcrumb: "Details",
    backToList: "Back",
    downloadPdf: "Generate Report",
    editReceive: "Edit",
    amountLabel: "Amount",
    grandTotalLabel: "Total Amount",
    table: {
      srNo: "#",
      party: "Party",
      date: "Date",
      totalQty: "Total Quantity",
      grandTotal: "Total Amount",
      actions: "Actions",
    },
    viewTable: {
      sr: "SR",
      item: "Item",
      itemSize: "Item Size",
      subProcess: "Sub Process",
      rawMaterial: "Raw Material",
      qty: "Qty",
      rate: "Rate",
      amount: "Amount",
    },
  },
}
